import { graphql, useFragment } from "react-relay";

import type { useSsoApiKeysBlocked_query$key } from "./__generated__/useSsoApiKeysBlocked_query.graphql";

/**
 * Whether the viewer's personal API keys are blocked: they sign in through SSO
 * and the platform has SSO API keys switched off. A fragment rather than a
 * query of its own, so a page that already selects from `Query` pays no extra
 * round trip for the answer.
 */
export function useSsoApiKeysBlocked(
  queryRef: useSsoApiKeysBlocked_query$key,
): boolean {
  const data = useFragment(
    graphql`
      fragment useSsoApiKeysBlocked_query on Query {
        platform {
          ssoAPIKeys
        }
        whoami {
          user {
            ssoUser
          }
        }
      }
    `,
    queryRef,
  );

  return data.whoami.user.ssoUser && !data.platform.ssoAPIKeys;
}
